const getQuestionnaireSubsectionIdentifier = subsection => {
    if (subsection.isCustom) {
        return `CUSTOM_SUBSECTION_${subsection.id}`;
    }

    return `SUBSECTION_${subsection.id}`;
};

export default getQuestionnaireSubsectionIdentifier;
